import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BankModalService {

  private selectedBankSubject = new BehaviorSubject<any>(null);
  public selectedBank$ = this.selectedBankSubject.asObservable();

  constructor() { }

  setSelectedBank(bank: any): void {
    this.selectedBankSubject.next(bank);
  }

  getSelectedBank(): any | null {
    return this.selectedBankSubject.value;
  }

  clearSelectedBank(): void {
    this.selectedBankSubject.next(null);
  }
}
